import { Play, Pause, ShoppingBag, Check } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { usePlayer } from "@/context/PlayerContext";
import { resolveImg } from "@/lib/api";

export default function TrackCard({ track, queue, onBuy }) {
  const { t } = useI18n();
  const { current, playing, playTrack, togglePlay } = usePlayer();
  const isCurrent = current?.id === track.id;
  const isPlaying = isCurrent && playing;

  const handlePlay = () => {
    if (isCurrent) togglePlay();
    else playTrack(track, queue || [track]);
  };

  return (
    <div
      className="card-interactive overflow-hidden group"
      data-testid={`track-${track.id}`}
    >
      <div className="relative aspect-square">
        <img src={resolveImg(track.cover)} alt={track.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
        <button
          onClick={handlePlay}
          className="absolute bottom-3 right-3 w-12 h-12 rounded-full bg-white text-black grid place-items-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all active:scale-95 shadow-xl"
          data-testid={`track-play-${track.id}`}
          aria-label="play"
        >
          {isPlaying ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
        </button>
        <span className="absolute top-3 left-3 chip bg-black/60 backdrop-blur text-white border border-white/10">
          {track.genre}
        </span>
        {!track.owned && !track.is_free && track.price > 0 && (
          <span className="absolute top-3 right-3 chip bg-[#FF0050]/80 backdrop-blur text-white border border-white/10 text-[10px]" data-testid={`track-preview-${track.id}`}>
            Extrait {track.preview_duration || 30} s
          </span>
        )}
      </div>
      <div className="p-4">
        <p className="font-semibold text-white truncate">{track.title}</p>
        <p className="text-xs text-zinc-400 truncate">{track.artist_name}{track.feat?.length ? ` · feat. ${track.feat.join(", ")}` : ""}</p>
        {(track.producers?.length || track.label) ? (
          <p className="text-[10px] text-zinc-500 truncate mt-1">
            {track.producers?.length ? `Prod. ${track.producers.join(", ")}` : ""}
            {track.producers?.length && track.label ? " · " : ""}
            {track.label || ""}
          </p>
        ) : null}
        <div className="mt-3 flex items-center justify-between">
          <span className="text-lg font-black font-display text-white">
            {track.is_free ? "FREE" : `$${track.price.toFixed(2)}`}
          </span>
          {track.owned ? (
            <span className="inline-flex items-center gap-1 chip bg-emerald-500/15 text-emerald-300">
              <Check className="w-3 h-3" /> {t.store.owned}
            </span>
          ) : track.is_free ? (
            <span className="chip bg-[#00F2FE]/15 text-[#00F2FE]">FREE</span>
          ) : (
            <button
              onClick={() => onBuy && onBuy(track)}
              className="btn-primary py-2 px-4 text-xs inline-flex items-center gap-1"
              data-testid={`track-buy-${track.id}`}
            >
              <ShoppingBag className="w-4 h-4" /> {t.store.buy}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
